import { CxsBasket } from '../model';

export const addGiftCard = (basket: CxsBasket, code: string): CxsBasket => {
    const { giftCardCodes } = basket;
    const newCode = code.toLocaleUpperCase().trim();
    if (giftCardCodes.find(existingCode => existingCode.toLocaleUpperCase() === newCode)) {
        return basket;
    }
    return {
        ...basket,
        giftCardCodes: giftCardCodes.concat(newCode)
    };
};
